// Import configs file
const configs = require('../configs');
import intlTelInput from 'intl-tel-input';
// Import global functions from functions.js
const { getSerializeForm, getParamValue, removeURLParameter, isEmail } = require('./functions.js');

var phoneInputField = null;
var phoneInput = null;

/*global intlTelInputUtils*/

jQuery(() => {
	// Modals Click
	$(document).on('click', '[data-toggle="modal"]', function(){

		if ($(this).attr('data-target') == '#doctorModal') {
			var doctorHtml = $(this).closest('.col-doctor').html();
			$('#doctorModal').find('.modal-body').html(doctorHtml);
		}

	});

	// Video modal
	var $videoSrc;
	$(document).on('click', '.video-link', function(){
		$videoSrc = $(this).attr('data-src');
	});

	$(document).on('shown.bs.modal', '#videoModal', function(){
		$('#videoModal').find('.video').attr(
			'src',
			$videoSrc + '?autoplay=1&showinfo=0&modestbranding=1&rel=0&mute=1'
		);
	});

	$(document).on('hide.bs.modal', '#videoModal', function(){
		$('#videoModal').find('.video').attr('src', $videoSrc);
	});

	// Scroll avec les encres
	$(document).on('click', '.encre', function(){

		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		}

	});

	// Contact Form
	$(document).on('submit', '#informations-form', function(e){

		e.preventDefault();
		// Add loading class
		$('#informations-form').closest('.container').find('.spinner-container').addClass('show');
		var formData = getSerializeForm($(this));

		if (formData.email && !isEmail(formData.email)) {
			$('#email').next('small').first().text($('#email').attr('data-invalid'));
			// Remove loading class
			$('#informations-form').closest('.container').find('.spinner-container').removeClass('show');
			return false;
		} else {
			$('#email').next('small').first().text('');
		}
		
		if(!formData.number_type) {
			$('#error-number-type').text($('#number_type').attr('data-invalid'));
			$('#informations-form').closest('.container').find('.spinner-container').removeClass('show');
			return false;
		} else {
			$('#error-number-type').text('');
			formData.isMobile = formData.number_type === 'mobile' ? true : false;
			delete formData['number_type'];
		}

		if (!phoneInput.isValidNumber()) {
			$('#error-mobile').text($('#mobile').attr('data-invalid'));
			$('#informations-form').closest('.container').find('.spinner-container').removeClass('show');
			return false;
		} else {
			$('#error-mobile').text('');
			const mobile = phoneInput.getNumber(intlTelInputUtils.numberFormat.E164);
			formData.mobile = mobile;
		}

		formData.name = formData.first_name + ' ' + formData.last_name;
		formData.clinicId = getParamValue('id');
		delete formData['first_name'];
		delete formData['last_name'];

		$.ajax({
			type: 'post',
			url: `${configs.apiUrl}/email/contact`,
			data: JSON.stringify(formData),
			contentType: 'application/json; charset=utf-8',
			dataType : 'json',
			success: function (response) {
				// Remove loading class
				$('#informations-form').closest('.container').find('.spinner-container').removeClass('show');
				// Reset form field
				document.getElementById('informations-form').reset();
				if (response.statusCode == 202) {
					$('.alert-informations').text('Votre message a été envoyé avec succès.').removeClass('alert-danger').addClass('alert-primary').removeClass('d-none');
				} else {
					$('.alert-informations').text('Une erreur s\'est produite et votre message n\'a pas été envoyé. Veuillez réessayer dans quelques instants.').removeClass('alert-primary').addClass('alert-danger').removeClass('d-none');
				}
				setTimeout(function() {
					$('.alert-informations').addClass('d-none');
					window.parent.postMessage('', '*');
				},4000);
			},
			error: function () {
				// Remove loading class
				$('#informations-form').closest('.container').find('.spinner-container').removeClass('show');
				$('.alert-informations').text('Une erreur s\'est produite et votre message n\'a pas été envoyé. Veuillez réessayer dans quelques instants.').removeClass('alert-primary').addClass('alert-danger').removeClass('d-none');
				setTimeout(function() {
					$('.alert-informations').addClass('d-none');
					window.parent.postMessage('', '*');
				},4000);
			}
		});

		return false;

	});

	// Guide Form
	$(document).on('submit', '#guide-form', function(e){

		e.preventDefault();

		var form = $(this);
		var formData = getSerializeForm(form);

		// Add loading class
		form.closest('.modal').find('.spinner-container').addClass('show');
		
		if (formData.email && !isEmail(formData.email)) {
			$('#email-guideModal').next('small').first().text($('#email-guideModal').attr('data-invalid'));
			// Remove loading class
			form.closest('.modal').find('.spinner-container').removeClass('show');
			return false;
		} else {
			$('#email-guideModal').next('small').first().text('');
		}

		formData.name = formData.first_name + ' ' + formData.last_name;

		delete formData['first_name'];
		delete formData['last_name'];

		formData.clinic = getParamValue('id');

		$.ajax({
			type: 'post',
			url: `${configs.apiUrl}/email/guide`,
			data: JSON.stringify(formData),
			contentType: 'application/json; charset=utf-8',
			dataType : 'json',
			success: function (response) {
				// Remove loading class
				form.closest('.modal').find('.spinner-container').removeClass('show');
				// Reset form field
				document.getElementById('guide-form').reset();
				if (response.statusCode < 300) {
					form.closest('.modal').find('.alert-form').text('Un email vous a été envoyé.').removeClass('alert-danger').addClass('alert-primary').removeClass('d-none');
				} else {
					form.closest('.modal').find('.alert-form').text('Une erreur s\'est produite et votre message n\'a pas été envoyé. Veuillez réessayer dans quelques instants.').removeClass('alert-primary').addClass('alert-danger').removeClass('d-none');
				}
				setTimeout(function() {
					form.closest('.modal').find('.alert-form').addClass('d-none');
					form.closest('.modal').find('.modal').find('.close').trigger('click');
				},4000);
			},
			error: function () {
				// Remove loading class
				form.closest('.modal').find('.spinner-container').removeClass('show');
				form.closest('.alert-form').text('Une erreur s\'est produite et votre message n\'a pas été envoyé. Veuillez réessayer dans quelques instants.').removeClass('alert-primary').addClass('alert-danger').removeClass('d-none');
				setTimeout(function() {
					form.closest('.alert-form').addClass('d-none');
				},4000);
			}
		});

		return false;

	});

	// Rate Click Event
	$(document).on('click', '.rate-stars span.fa-star', function(){

		$(this).closest('.rate-stars').find('span.fa-star').removeClass('checked');
		$(this).addClass('checked');
		$(this).closest('.rate-stars').find('input[type="hidden"]').val(Math.abs(($(this).closest('.rate-stars').find('span.fa-star.checked').index()) - 5));

	});

	// Menu service Event Click
	$(document).on('click', '.dropdown-menu.services .dropdown-item', function(e){

		e.preventDefault();

		if ($(this).hasClass('active')) {return false;}

		const service = $(this).data('service');
		const currentUrl = $(this).attr('href');
		let newUrl = currentUrl;
		const currentServName = getParamValue('service');

		if (currentServName !== null) {
			newUrl = removeURLParameter(currentUrl, 'service');
			newUrl = newUrl + '&service=' + service;
			window.location.href = newUrl;
		} else {
			newUrl = newUrl + '&service=' + service;
			window.location.href = newUrl;
		}

	});

	// Close menu when body is clicked
	$(document).on('click', function (event) {
		if ($(window).width() < 992) {
			var clickover = $(event.target);
			var _opened = $(document).find('.navbar-collapse').hasClass('show');
			if (_opened === true && !clickover.hasClass('navbar-toggler') && !clickover.hasClass('dropdown') && clickover.closest('.nav-item.dropdown').length === 0) {
				$('.navbar-collapse').collapse('hide');
			}
		}
	});

	$(document).on('click', '.openAppointmentModal', () => {
		$('#appointmentModal').modal('show');
	});

	// eslint-disable-next-line no-unused-vars
	window.addEventListener('message', _event => {
		$('#appointmentModal').modal('hide');
	});

	phoneInputField = document.querySelector('#mobile');
	if(phoneInputField) {
		const telInputFlag = phoneInputField.getAttribute('data-location');

		phoneInput = intlTelInput(phoneInputField, {
			initialCountry: telInputFlag,
			utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
		});
	}
});